import React from 'react';

const EnvDebug: React.FC = () => {
    // Only show in development or when explicitly enabled
    if (import.meta.env.MODE === 'production') {
        return null;
    }

    if (!import.meta.env.VITE_SHOW_DEBUG) {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '10px',
                right: '10px',
                backgroundColor: 'rgba(0,0,0,0.7)',
                color: 'white',
                padding: '10px',
                borderRadius: '5px',
                fontSize: '12px',
                zIndex: 9999,
            }}
        >
            <div>
                <strong>Environment:</strong> {import.meta.env.MODE}
            </div>
            <div>
                <strong>API URL:</strong> {import.meta.env.VITE_API_V1_URL}
            </div>
            <div>
                <strong>No Version API URL:</strong>{' '}
                {import.meta.env.VITE_NOVERSION_API_URL}
            </div>
        </div>
    );
};

export default EnvDebug;
